const putDynamicValuesToLink = (link, data) => {
  const regExToFindPlaceholders = /\[(.*?)\]/g;
  const linkWithDynamicValues = link.replace(regExToFindPlaceholders, (m, key) =>
    Object.prototype.hasOwnProperty.call(data, key) ? data[key] : '',
  );
  return encodeURI(linkWithDynamicValues);
};

export default putDynamicValuesToLink;
